import $ from "jquery";
const meetOurLeaders = {
    variable:{
        url: window.location.href,
    },
    methods: {
        meetOurLeadersButtonClickHandler: function () {
            $(document).on('click', '.card-cta', function() {
                          const buttonText = $(this).text();
                          let section = $(this).closest('.genericContainer');
                          let titleText = section.prev('.genericContainer').find('.chli_title .heading-2').text().trim();
                          let pageName = getPageName(meetOurLeaders.variable.url);
                          let pageSection = pageName + "_" + titleText;
                          let obj = meetOurLeaders.methods.dataLayerObj(buttonText, pageSection);
                          createDataLayer('buttonClick', obj);
                      });
        },
        dataLayerObj: function (e,el) {
                  var obj = {
                    'articleName': "",
                    'blogCategory': "",
                    'blogPageCategory': "",
                    'buttonText': e?e.replace(/\n/g, '').trim():"",
                    'pageSection': el ? el : "",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? meetOurLeaders.variable.url.includes("blog") ? "Blogs" : meetOurLeaders.variable.url.substring(meetOurLeaders.variable.url.indexOf(".com/"), meetOurLeaders.variable.url.lastIndexOf('/')  === ".com") && !meetOurLeaders.variable.url.substring(meetOurLeaders.variable.url.indexOf(".com/"), meetOurLeaders.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption': "",
                    'productCategory': "",
                    'productName': "",
                    'question': "",
                    'source': "",
                    'searchTerm': "",
                    'videoTitle': "",
                    'bannerName': "",
                  };
                  return obj;
                },
        }
    };

$(document).ready(function () {
    meetOurLeaders.methods.meetOurLeadersButtonClickHandler();
});

$(() => {
    function getRandomClass(excludeClass) {
        const classes = ['blue-bg', 'red-bg', 'yellow-bg'];
        let randomClass;

        do {
            randomClass = classes[Math.floor(Math.random() * classes.length)];
        } while (randomClass === excludeClass);

        return randomClass;
    }

    function addClassPattern() {
        const divs = document.querySelectorAll('.leader-cards');
        let lastClass = '';

        divs.forEach(div => {
            const newClass = getRandomClass(lastClass);
            div.classList.add(newClass);
            lastClass = newClass;
        });
    }

    function addMobileClickEvent() {
        const cards = document.querySelectorAll('.card');

        cards.forEach(card => {
            card.addEventListener('click', function() {
                // Toggle 'active' class on click
                card.classList.toggle('active');
            });
        });
    }

    addClassPattern();
    addMobileClickEvent();
});
